<app-dialog [visible]="visible" title="Upload excel document" [fullscreenOnMobile]="true"
    class="max-w-[37rem]" (closed)="dialogClosed()">
    <ng-template #bodyTemplate>
        <div class="flex flex-col px-6 py-4">
            @if(showUploadOptions){
            <div class="flex w-full mb-4 border border-gray-200 rounded-lg overflow-hidden">
                @for(option of uploadOptions; track option.value) {
                <app-button [label]="option.label" [variant]="selectedType === option.value ? 'filled' : 'text'"
                    [severity]="selectedType === option.value ? 'primary' : 'contrast'" class="flex-1 !rounded-none"
                    (clicked)="selectUploadType(option.value)" />
                }
            </div>
            }
            <div class="mb-5">
                <app-file-drop [class]="dragAreaClass" [fileTypes]="fileTypes" [maxFileSize]="maxFileSize"
                    (uploadData)="onFileUploaded($event)" (removeFile)="onFileRemove($event)"
                    [existingFiles]="uploadedFile ? [uploadedFile] : []"></app-file-drop>
            </div>
            <p class="self-center text-center text-black">Download the sample sheet from <a
                    class="underline underline-offset-4 text-arena-orange cursor-pointer"
                    (click)="downloadSampleExcel()">{{"here" | titlecase}}</a>
            </p>
            @if(downloadExistingExcelData){
            <p class="self-center text-center text-black">Download existing data from <a
                    class="underline underline-offset-4 text-arena-orange cursor-pointer"
                    (click)="downloadExistingExcel()">{{"here" | titlecase}}</a>
            </p>
            }
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Cancel" variant="outlined" severity="contrast" (clicked)="cancel()" />
            <app-button label="Upload" variant="filled" severity="primary" (clicked)="onSubmit()"
                [disabled]="!uploadedFile" />
        </div>
    </ng-template>
</app-dialog>